module.exports = __webpack_public_path__ + "static/media/aquatic_centre.77a825ec.jpg";